<script lang="ts">
  import AlertCard from '$components/alert-card.svelte';

  import { t } from '$lib/i18n';

  import type { GetProductQuery } from '$gql/storefront/operations';
  import { getProductAlertId } from './alerts';

  export let isPreSale: boolean;
  export let wontBeRestocked: boolean;
  export let product: NonNullable<GetProductQuery['product']>;
  export let wishlistCounter: string | undefined = undefined;
  export let hasOnlyOneVariantForSaleStock: string | false = false;

  const message = getProductAlertId(product, {
    isPreSale,
    wontBeRestocked,
    wishlistCounter
  });

  const few = $t('pdp.alerts.product.few');
</script>

{#if message}
  <AlertCard
    message={$t(message, {
      wishlistCounter: wishlistCounter || '0',
      hasOnlyOneVariantForSaleStock: hasOnlyOneVariantForSaleStock || few
    })}
    class="mb-4 mt-2 lg:mt-0"
  />
{/if}
